import { useQuery } from '@tanstack/react-query';
import { budgetStatusApi } from '../api/budgetStatus';

export const useBudgetStatuses = () => {
  return useQuery({
    queryKey: ['budgetStatuses'],
    queryFn: () => budgetStatusApi.list(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  });
};
